// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transcript_wrapper__-9Z3T {
  background-color: var(--backgroundColor);
}

.transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U {
    position: -webkit-sticky;
    position: sticky;
    bottom: 8px;

    display: flex;
    gap: 4px;
    align-items: center;
    align-self: center;

    margin-top: 12px;
    padding: 8px 14px 8px 14px;
    border-radius: 3px;

    font-size: 14px;
    font-weight: 700;
    line-height: 17.07px;
    color: var(--backgroundColor);

    background-color: var(--textColor);
    box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);

    transition: background-color 0.2s ease-in-out;
  }

.dark .transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U:hover {
  background-color: rgba(245, 245, 245, 1);
}

.light .transcript_wrapper__-9Z3T .transcript_syncWithVideoButton__UQB2U:hover {
  background-color: rgba(51, 51, 51, 1);
}
`, "",{"version":3,"sources":["webpack://./src/components/transcript/transcript.module.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;AAyB1C;;AAvBE;IACE,wBAAgB;IAAhB,gBAAgB;IAChB,WAAW;;IAEX,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;;IAElB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;;IAElB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,6BAA6B;;IAE7B,kCAAkC;IAClC,+CAA+C;;IAE/C,6CAA6C;EAC/C;;AAGF;EACE,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[".wrapper {\n  background-color: var(--backgroundColor);\n\n  & .syncWithVideoButton {\n    position: sticky;\n    bottom: 8px;\n\n    display: flex;\n    gap: 4px;\n    align-items: center;\n    align-self: center;\n\n    margin-top: 12px;\n    padding: 8px 14px 8px 14px;\n    border-radius: 3px;\n\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 17.07px;\n    color: var(--backgroundColor);\n\n    background-color: var(--textColor);\n    box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);\n\n    transition: background-color 0.2s ease-in-out;\n  }\n}\n\n:global(.dark) .wrapper .syncWithVideoButton:hover {\n  background-color: rgba(245, 245, 245, 1);\n}\n\n:global(.light) .wrapper .syncWithVideoButton:hover {\n  background-color: rgba(51, 51, 51, 1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `transcript_wrapper__-9Z3T`,
	"syncWithVideoButton": `transcript_syncWithVideoButton__UQB2U`
};
export default ___CSS_LOADER_EXPORT___;
